import { LoadingContainer } from "./style";
import { ReactComponent as LogoIcon } from "../../icons/svg/icon.svg";
import { Spinner } from "@grupoboticario/flora-react";

export default function Loading() {
    return (
        <LoadingContainer>
            <LogoIcon style={{width: "40px", height: "auto"}}/>
            <span style={{fontSize: "12px"}}>CARREGANDO</span>
            <Spinner size="sm" />
        </LoadingContainer>
    )
}